import { createFileRoute } from '@tanstack/react-router'
import { ApiDocsPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/api-docs')({
  head: () => staticRouteHead('apiDocs', 'it'),
  component: ApiDocsPage,
})
